module.exports = __webpack_public_path__ + "img/404.e005cefb.png";